import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createOptionLabel: {
		id: 'polaris-ideas.view-content.idea-board-next.column-footer.search-and-create.create-option-label',
		defaultMessage: 'Create {issueTypeName} "{inputValue}"',
		description: 'Label for create option in the dropdown for adding or creating issues',
	},
});
